





























import { defineComponent } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import HeaderLink from '@front-app/components/header/HeaderLink.vue';
import { Routes } from '@front-app/constants/routes';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		HeaderLink,
	},
	setup() {
		return {
			Routes,
		};
	},
});
